import { TrustPilotStars as UITrustPilotStars } from "@jti/ui/components/TrustPilotStars/TrustPilotStars";

import type { TrustPilotStarsProps } from "./TrustPilotStars.builder";

export function TrustPilotStars(props: TrustPilotStarsProps) {
  return (
    <UITrustPilotStars
      sku={props.sku}
      height={props.height}
      width={props.width}
      starColor={props.starColor}
      reviewNumber={props.reviewNumber}
      scrollToList={props.scrollToList}
      styleAlignment={props.styleAlignment}
    />
  );
}
